/**
 * Messages d’indisponibilité des références (autre booster actif sur la période).
 */
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { ReferenceReferenceReadModel } from '@r/api/generated/client.schemas.ts';
import { formatBoosterTiersCoefficientSummary } from './booster-reference-tiers.ts';

/** Date affichée dans les tooltips / toasts de conflit booster. */
export function formatBoosterConflictDate(value: string) {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return format(date, 'dd/MM/yyyy', { locale: fr });
}

/** Texte complet au survol d’une ligne référence grisée (conflit de période). */
export function getBoosterReferenceConflictHint(
  reference: ReferenceReferenceReadModel,
  t: (key: string, options?: Record<string, unknown>) => string
) {
  const activeBooster = reference.activeBooster;

  if (!activeBooster) {
    return t('boosters.create.references.conflict.hint.generic');
  }

  const coefficientSummary =
    formatBoosterTiersCoefficientSummary(reference.activeBoosterTiers) ??
    t('boosters.create.references.conflict.coefficient.unknown');

  return t('boosters.create.references.conflict.hint', {
    startDate: formatBoosterConflictDate(activeBooster.startDate),
    endDate: formatBoosterConflictDate(activeBooster.endDate),
    coefficient: coefficientSummary
  });
}
